<template>
  <b-tooltip variant="danger" :target="target">Sorry, you don't have permission to do this action</b-tooltip>
</template>

<script>
export default {
  name: "NoPermissionTooltip",
  props: {
    target: String
  }
}
</script>
